import { ref, onMounted, onUnmounted, type Ref } from 'vue';

export const mobileMaxWidth = 700;

export function calculateIsMobile(): boolean {
	// At least in dev tools responsive mode, innerWidth does not immediately
	// reflect the correct width, but outerWidth does.
	return Math.min(window.innerWidth, window.outerWidth) < mobileMaxWidth;
}

export function useIsMobile(target?: Ref<HTMLElement | null>): Ref<boolean> {
	const isMobile = ref(calculateIsMobile());

	function update() {
		requestAnimationFrame(() => {
			isMobile.value = calculateIsMobile();
		});
	}

	const resizeObserver = target ? new ResizeObserver(update) : null;

	onMounted(() => {
		update();
		if (resizeObserver && target?.value)
			resizeObserver.observe(target.value);
		else
			window.addEventListener('resize', update);
	});

	onUnmounted(() => {
		resizeObserver?.disconnect();
		window.removeEventListener('resize', update);
	});

	return isMobile;
}
